export enum IPItemTypes {
	IPDocument = 3,
	IPDocumentLA = 4,
}